import React from 'react';
import Icon from '../AppIcon';

const PublicHeader = () => {
  return (
    <header className="fixed top-0 left-0 right-0 z-[100] border-b border-border shadow-elevation-1" style={{ backgroundColor: '#065395' }}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center space-x-3">
            <div className="flex items-center justify-center w-16 h-16 rounded-lg overflow-hidden bg-white/10 p-1">
              <img
                src="/assets/images/rpm-logo-1783614933281.png"
                alt="RPM Diesel Services Logo"
                className="w-full h-full object-contain"
              />
            </div>
            <div className="flex flex-col">
              <span className="text-lg font-semibold text-white leading-tight">RPM Diesel Driver Portal</span>
              <span className="text-xs text-white/70 hidden sm:block">Driver Portal</span>
            </div>
          </div>

          <nav className="flex items-center space-x-4">
            <a
              href="tel:+1-800-555-0100"
              className="flex items-center space-x-2 px-3 py-2 text-sm font-medium text-white/80 hover:text-white transition-hover rounded-md hover:bg-white/10"
            >
              <Icon name="Phone" size={18} strokeWidth={2} color="currentColor" />
              <span className="hidden sm:inline">Support</span>
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default PublicHeader;